import { useState } from "react";
import {
  Accordion,
  Col,
  Dropdown,
  Modal,
  Nav,
  Offcanvas,
  Row,
  Table,
  Form,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import "./salesOrders.css";
import "../../Utils/assets/css/styles.css";
import { useNavigate } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";
import {
  downloadPdf,
  formatDate,
  formatToINR,
  printPdf,
  TextWithLineBreaks,
} from "../../Utils/helpers/commonhelper";
import {
  DeleteRequest,
  PostRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import { baseURL } from "../../Utils/constants/constant";
import { imageURL } from "../../Utils/constants/constant";
import DeleteModal from "../DeleteModal";
import { EditSalesOrder } from "./EditSalesOrder";
import pugcrm_logo from "./.././../Utils/assets111/img/pugcrm_logo.png";

export const SalesOrderDetailsOffcanvas = ({
  isMyApproval,
  setShowSalesOrderDetails,
  show,
  handleClose,
  salesDetails,
  fetchSalesOrder,
  isClone,
  setIsEditOpen,
  isEditOpen,
  // handleCloneClick,
  // handleEditClick,
}) => {
  const navigate = useNavigate();

  //parse items detail
  const itemsDetailsData = salesDetails?.items
    ? JSON.parse(salesDetails.items)
    : "";

  const [activeTab, setActiveTab] = useState("invoice");

  //delete sales order
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // edit state
  const [editOpen, setEditOpen] = useState(false);
  // clone state
  const [openClone, setOpenClone] = useState(false);
  // pdf view toggle
  const [pdfView, setPdfView] = useState(false);
  const [loading, setLoading] = useState(false)

  // parse billing address
  const parsedBillingAddress = salesDetails?.billing_address
    ? JSON.parse(salesDetails?.billing_address)
    : "";

  const parsedShippingAddress = salesDetails?.shipping_address
    ? JSON.parse(salesDetails?.shipping_address)
    : "";

  const parsedCompanyBillingAddress = salesDetails?.company_billing_address
    ? JSON.parse(salesDetails?.company_billing_address)
    : "";

  // order status and reject reason state
  // const [orderStatus, setOrderStatus] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [openRejectReasonModal, setOpenRejectReasonModal] = useState(false);

  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  });

  const customer_id = customer?.customer_details?.customer_id || 1;
  const token = customer?.token?.authorization || "";
  const rf = customer?.token?.authentication || "";
  const extras = { customer, setCustomer, rf, navigate };
  const headers = {
    Authorization: token,
    Authentication: rf,
  };

  const sendSalesOrder = async () => {
    const payload = {
      customer_id: customer_id,
      order_id: salesDetails?.id,
      user_login_id: customer?.customer_details?.id,
    };
    const res = await PostRequest(
      `sales/sendSalesOrder`,
      payload,
      false,
      { headers },
      { extras },
    );
  };
  const handleConfirmDelete = async () => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `sales/deleteSalesOrder/${salesDetails.id}/${customer?.customer_details?.id}`,
        { headers },
        { extras },
      );
      if (res?.status === "success") {
        toast.success(res.message);
        await fetchSalesOrder();
      } else if (res.status === "fail") {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("delete error:", error);
    } finally {
      setShowSalesOrderDetails(false);
      setShowDeleteModal(false);
      setLoading(false)
    }
  };

  // approve or reject order
  const approveOrder = async (status) => {
    const payload = {
      order_id: salesDetails.id || "",
      order_status: status === true ? "reject" : "approved" || " ",
      reject_reason: rejectReason || " ",
    };
    const res = await PutRequest(
      `/sales/ChangeStatusOFSalesOrder`,
      payload,
      { headers },
      { extras },
    );
    if (res.status !== "success") {
      toast.error(res.message);
    }
    if (res.status === "success") {
      fetchSalesOrder();
      toast.success(res.message);
      setShowSalesOrderDetails(false);
    }
  };

  const handleSalesOrderDetails = async (id) => {
    // if (!id) return;
    // try {
    //     const res = await GetRequest(
    //         `/sales/fetchDetailsOfSpecificOrder/${id}`,
    //         { headers },
    //         extras
    //     );
    //     if (res.status === "success") {
    //         const editDataToSet = res.data;
    //         setEditData(editDataToSet[0]);
    //         setSalesOrderDetailsOffcanvas(true);
    //         setIsClone(false);
    //         setsalesOrderId(id);
    //     }
    // } catch (error) {
    //     console.error(error);
    // }
  };

  const handlePurchaseOrderDetails = async () => { };

  // handle print function
  //   const handlePrint = async (endpoint, customerId,moduleId) => {
  //   const fileUrl =` ${baseURL}/${endpoint}/${customerId}/${moduleId}`;

  //   // PDF ko blob me fetch karna
  //   const res = await fetch(fileUrl, { method: "GET" });
  //   const blob = await res.blob();
  //   const pdfUrl = URL.createObjectURL(blob);

  //   const printWindow = window.open("", "_blank");
  //   printWindow.document.write(`
  //     <html>
  //       <head>
  //         <title>Print Preview</title>
  //         <style>
  //           body, html {
  //             margin: 0;
  //             padding: 0;
  //             height: 100%;
  //             overflow: hidden;
  //           }
  //           iframe {
  //             width: 100%;
  //             height: 100%;
  //             border: none;
  //           }
  //           .toolbar {
  //             position: fixed;
  //             top: 0;
  //             left: 0;
  //             width: 99%;
  //             background: #f5f5f5;
  //             border-bottom: 1px solid #ccc;
  //             padding: 8px;
  //             display: flex;
  //             justify-content: flex-end;
  //             gap: 10px;
  //             z-index: 9999;
  //           }
  //           .toolbar button, .toolbar a {
  //             background: #1976d2;
  //             color: white;
  //             padding: 6px 12px;
  //             border-radius: 4px;
  //             border: none;
  //             cursor: pointer;
  //             text-decoration: none;
  //           }
  //         </style>
  //       </head>
  //       <body>
  //         <div className="toolbar">
  //           <button onclick="window.print()">Print</button>
  //           <a href="${pdfUrl}" download>Download</a>
  //         </div>
  //         <iframe src="${pdfUrl}" frameborder="0"></iframe>
  //       </body>
  //     </html>
  //   `);
  //   printWindow.document.close();
  // };
  // if(isEditOpen && salesDetails){
  //   return(
  //     <EditSalesOrder
  //     data={salesDetails}
  //     isClone={is}
  //     />
  //   )
  // }

  // if (showDeleteModal) {
  //   return (
  //     <DeleteModal
  //       show={showDeleteModal}
  //       onClose={() => setShowDeleteModal(false)}
  //       onConfirm={handleConfirmDelete}
  //       message={"Are you sure you want to delete this sales order"}
  //     />
  //   );
  // }
  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        backdrop="static"
        className="offcanvas offcanvas-end w-75"
      >
        <div
          className="offcanvas-header align-items-center border-bottom justify-content-between py-3 px-4"
          id="saleOrderDetails"
          aria-labelledby="staticBackdropLabel"
        >
          {/* <h5 className="offcanvas-title" id="staticBackdropLabel">
            {` Sales Order Details-  #${salesDetails.sale_no || "-"}`}
          </h5> */}
          <h3
            className=" mb-0"
            style={{
              whiteSpace: "nowrap",
              fontWeight: 300,
              fontSize: "22px",
            }}
          >
            Sales Order Details-
            <span className="ms-1" style={{ color: "#0099ff" }}>
              #{salesDetails.sale_no}
            </span>
          </h3>
          <div className="d-flex align-items-center">
            {/* <label htmlFor="pic" className="divslabel me-2">
            <span>
              <i className="bi bi-user"></i>
              Upload File |
            </span>
            <input type="file" id="pic" className="uploadsInput" />
          </label> */}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
        </div>

        <Offcanvas.Body style={{ paddingLeft: 31, paddingRight: 31 }}>
          <DeleteModal
            show={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            onConfirm={handleConfirmDelete}
            isLoading={loading}
            message={"Are you sure you want to delete this sales order"}
          />
          {/* List */}
          <div className="row d-flex align-items-center">
            <div className="col-md-9">
              {" "}
              <ul className="list-unlisted gap-1">
                <li
                  style={{ color: "#0099ff" }}
                  className="listed d-flex gap-1 align-items-center px-3px-3"
                  // onClick={() => {
                  //   setEditOpen(true);
                  //   setShowSalesOrderDetails(false);
                  //   handleEditClick(salesDetails.id);
                  // }}
                  onClick={() =>
                    navigate(`/editsalesorder/${salesDetails?.id}`, {
                      state: { mode: "edit", from: "detailPage" },
                    })
                  }
                >
                  <i className="bi bi-pencil-square"></i>
                  Edit
                </li>
                <li
                  className="listed d-flex gap-1 align-items-center px-3"
                  style={{ color: "#0099ff" }}
                >
                  <i className="bi bi-envelope"></i>
                  Email
                </li>
                <Dropdown as="div" className="dropdownsWithoutToggle">
                  <Dropdown.Toggle as={Nav.Link} className="header-link">
                    <li
                      className="listed d-flex gap-1 align-items-center px-3"
                      style={{ color: "#0099ff" }}
                    >
                      <i class="bi bi-printer"></i>
                      PDF/Print
                    </li>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                    style={{ right: "3.4rem" }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      // onClick={()=>handlePrint(`/sales/downloadSalesOrder/`, customer_id, salesDetails.id)}
                      onClick={() => {
                        printPdf(
                          `${baseURL}/sales/downloadSalesOrder/${customer_id}/${salesDetails.id}`,
                          headers,
                          "print",
                        );
                      }}
                    >
                      {" "}
                      Print{" "}
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        downloadPdf(
                          `${baseURL}/sales/downloadSalesOrder/${customer_id}/${salesDetails.id}`,
                          headers,
                          "download",
                          "sales_order",
                        );
                      }}
                      className="d-flex align-items-center"
                    >
                      {" "}
                      Download
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <li
                  className="listed d-flex gap-1 align-items-center"
                  style={{ color: "#0099ff" }}
                >
                  <i class="bi bi-file-earmark-text"></i>
                  Invoice
                </li>
                <li
                  className="listed d-flex gap-1 align-items-center px-3"
                  style={{ color: "#0099ff" }}
                >
                  <i class="bi bi-layers"></i>
                  Projects
                </li>
                <li
                  className="listed px-3"
                  onClick={sendSalesOrder}
                  style={{ color: "#0099ff" }}
                >
                  <i class="bi bi-send"></i> Send
                </li>
                <Dropdown as="div" className="dropdownsWithoutToggle">
                  <Dropdown.Toggle as={Nav.Link} className="header-link">
                    <li className="listed px-2">
                      <div className="btn-group dropdownsWithoutToggle">
                        <button
                          type="button"
                          className=" dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{ border: "none", background: "none" }}
                        >
                          <i class="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                      </div>
                    </li>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                    style={{ right: "3.4rem" }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                    >
                      {" "}
                      Mark shipment as fulfilled{" "}
                    </Dropdown.Item>
                    {/* <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() =>
                        navigate(`/editsalesorder/${salesDetails?.id}`, {
                          state: { mode: "clone", from: "detailPage" },
                        })
                      }
                    >
                      {" "}
                      Clone
                    </Dropdown.Item> */}
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => setShowDeleteModal(true)}
                    >
                      {" "}
                      Delete{" "}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </ul>
            </div>
            <div className="col-md-3">
              {" "}
              {/* 🔽 PDF Toggle */}
              <div className="">
                <div className="float-end so-details-preview d-flex gap-2 align-items-center">
                  <i className="preview-label" id="a45f71bf0">
                    Show PDF View
                  </i>
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="toggleShowHidePdf"
                      onChange={() => setPdfView(!pdfView)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 🔽 What's Next
        <div className="mx-n5">
          <div className="rounded-lg m-5 ms-0 me-0 p-3 border">
            <div className="d-flex align-items-center flex-wrap">
              <div className="d-flex">
                <div className="font-xs text-semibold text-primary-black fs-13">
                  WHAT'S NEXT?
                </div>
              </div>
              <div className="my-auto d-flex align-items-center ms-2">
                <p className="font-small text-primary-black me-3 fs-13 mb-0">
                  Convert the sales order into packages, shipments, or invoices.
                </p>
                <div
                  id="dd-d13515e0-ba42-45d5-9d01-e19375f7bc58"
                  className="dropdown ember-view"
                >
                  <button
                    htmlFor="d13515e0-ba42-45d5-9d01-e19375f7bc58"
                    aria-controls="d13515e0-ba42-45d5-9d01-e19375f7bc58"
                    aria-haspopup="true"
                    aria-expanded="false"
                    className="dropdown-toggle no-caret  text-center btn btn-sm over-flow me-3 btn-primary"
                    type="button"
                  >
                    <span className="ps-1">Convert</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> */}
          <Row
            style={{
              width: "100%",
              marginLeft: 0,
              paddingRight: 4,
              // marginBottom: "1rem",
              // marginTop: "2rem",
            }}
            className="mt-4 mb-1"
          >
            <Col md={12} className="pe-0 ps-0">
              <Accordion
                defaultActiveKey="1"
                className="sales-order-accordion shadow-none border-0 focus-ring-0 w-100"
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="shadow-none border-0 focus-ring-0 bg-transparent">
                    Associated Details
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <div
                      className="d-flex mb-0 ms-3 gap-2"
                      style={{ alignItems: "center", height: "3rem" }}
                    >
                      {/* Quotation Button */}
                      <button
                        className="btn btn-link text-decoration-none px-2 py-1"
                        onClick={() => setActiveTab("quotation")}
                        style={{
                          backgroundColor:
                            activeTab === "quotation" ? "#007bff" : "#dedede",
                          color:
                            activeTab === "quotation" ? "#ffffff" : "#2a273f",
                          borderRadius: "3px",
                          fontSize: "12.8px",
                          border: "none",
                        }}
                      >
                        Quotation
                      </button>

                      <span className="text-secondary">|</span>

                      {/* Invoice Button */}
                      <button
                        className="btn btn-link text-decoration-none px-2 py-1"
                        onClick={() => setActiveTab("invoice")}
                        style={{
                          backgroundColor:
                            activeTab === "invoice" ? "#007bff" : "#dedede",
                          color:
                            activeTab === "invoice" ? "#ffffff" : "#383450ff",
                          borderRadius: "3px",
                          fontSize: "12.8px",
                          border: "none",
                        }}
                      >
                        Invoice
                      </button>
                    </div>

                    {activeTab === "invoice" ? (
                      <Table className="accordion-table">
                        <thead>
                          <tr>
                            <th style={{ borderTopLeftRadius: 0 }}>
                              Invoice Number
                            </th>
                            <th>Invoice Date</th>
                            <th>Invoice Due Date</th>
                            <th>Owner Name</th>
                            <th>Payment Terms</th>
                          </tr>
                        </thead>
                        <tbody>
                          {salesDetails?.invoice?.length > 0 ? (
                            salesDetails?.invoice?.map((quote, index) => (
                              <tr key={index}>
                                <td
                                  className="text-primary"
                                  style={{ cursor: "pointer" }}
                                >
                                  {quote.invoice_number || "-"}
                                </td>
                                <td>{formatDate(quote.invoice_date) || "-"}</td>
                                <td style={{ textAlign: "center" }}>
                                  {formatDate(quote.due_date) || "-"}
                                </td>
                                <td style={{ textTransform: "capitalize" }}>
                                  {quote.owner_name || "-"}
                                </td>
                                <td>{quote.payment_terms || "-"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={5}>No Data Found</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    ) : (
                      <Table className="accordion-table">
                        <thead>
                          <tr>
                            <th style={{ borderRadius: 0 }}>
                              Quotation Number
                            </th>
                            <th>Quotation Date</th>
                            <th>Expiry Date</th>
                            <th>Owner Name</th>
                            <th>Approve By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {salesDetails?.quotation?.length > 0 ? (
                            salesDetails?.quotation?.map((order, index) => (
                              <tr key={index}>
                                <td
                                  className="text-primary"
                                  style={{ cursor: "pointer" }}
                                >
                                  {order.quotation_number || "-"}
                                </td>
                                <td>
                                  {formatDate(order.quotation_date) || "-"}
                                </td>
                                <td>{formatDate(order.expiry_date) || "-"}</td>
                                <td style={{ textTransform: "capitalize" }}>
                                  {order.owner_name || "-"}
                                </td>
                                <td style={{ textTransform: "capitalize" }}>
                                  {order.approve_by_name || "-"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={5}>No Data Found</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>

          {/* 🔽 PDF Toggle */}
          {/* <div className="clearfix pb-3">
          <div className="float-end so-details-preview d-flex gap-2 align-items-center">
            <i className="preview-label" id="a45f71bf0">
              Show PDF View
            </i>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="toggleShowHidePdf"
                onChange={() => setPdfView(!pdfView)}
              />
            </div>
          </div>
        </div> */}

          {/* 🔽 Sales Order Details Section */}
          <div
            className="border-top-light border-bottom"
            id="normalViews"
            style={{ display: pdfView ? "none" : "block" }}
          >
            <div className="row w-100 ms-0 pt-4">
              <div
                // style={{ background: "#edffed" }}
                // className="row mb-3 pt-3 ms-0 w-100 border border-1"
                className="ms-0 w-100"
                style={{ backgroundColor: "#f4fff4" }}
              >
                <Row className="mt-4 px-1">
                  <Col md={6}>
                    <h3
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "#313131ff",
                      }}
                    >
                      Sales Order
                    </h3>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex align-items-end justify-content-end">
                      <span className="font-small">
                        <span style={{ fontWeight: 200 }}>Sales Order </span>
                        <strong className="font-small">
                          #{salesDetails?.sale_no || "-"}
                        </strong>
                      </span>
                    </div>
                  </Col>
                </Row>
                <hr />

                {/* Details Body */}
                <Row className="ms-0 w-100">
                  {/* Left Column: General Info */}
                  <Col md={6} className="ps-0 mb-4">
                    <h3
                      className="pt-0 ps-2 mb-2"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        marginBottom: 14,
                        color: "#0099ff",
                      }}
                    >
                      Customer Details
                    </h3>
                    <div style={{ borderRadius: 4 }} className="ps-2 mt-2">
                      <Row>
                        <Col md={12}>
                          <Form.Group className="mb-0" controlId="formCustomer">
                            <div className="d-flex align-items-center gap-2 mb-1">
                              <span
                                style={styles.cardLabel}
                                className="text-secondary"
                              >
                                Customer Name
                              </span>
                              <p
                                className="text-primary"
                                style={styles.cardLebelData}
                              >
                                <span className="pe-1 fw-semibold">:</span>
                                {salesDetails?.contact_full_name || "-"}
                              </p>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formOrderDate"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Order Date
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {formatDate(salesDetails?.sales_order_date)}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formShipmentDate"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Shipment Date
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {formatDate(salesDetails?.shipment_date)}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formSalesperson"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Sales Person
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {salesDetails?.owner_name || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formPaymentTerms"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Payment Terms
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {salesDetails?.payment_term || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      {/* Status Row */}
                      {/* <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formStatus"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Delivery Method
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1">:</span>
                              {salesDetails?.payment_term || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row> */}
                    </div>
                  </Col>

                  {/* Right Column: Addresses */}
                  <Col
                    md={6}
                    className="mb-4 d-flex flex-column ms-0 align-items-end"
                    style={{ textAlign: "end", paddingRight: "0.3rem" }}
                  >
                    {/* Billing Address */}
                    <div style={{ borderRadius: 4 }}>
                      <h3
                        className="pt-0 mb-2"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          marginBottom: 14,
                          color: "#0099ff",
                        }}
                      >
                        Billing Address
                      </h3>
                      <div className="mt-0 mb-2 col-md-12">
                        <div className="w-100 mb-3">
                          {parsedBillingAddress ? (
                            <>
                              {/* <div className="mb-0 fs-14 text-dark d-flex flex-column">
                                <span className="d-block fs-14 text-dark fw-bold">
                                  {salesDetails?.contact_full_name &&
                                    salesDetails?.contact_full_name}
                                </span>
                              </div> */}
                              <div
                                style={{ fontSize: "13px", fontWeight: 300 }}
                              >
                                <p
                                  style={{ fontSize: "13px", fontWeight: 300 }}
                                >
                                  {" "}
                                  {parsedBillingAddress?.address &&
                                    parsedBillingAddress?.address}
                                </p>
                                <p
                                  className="mb-3"
                                  style={{ fontSize: "13px", fontWeight: 300 }}
                                >
                                  {parsedBillingAddress?.city &&
                                    `${parsedBillingAddress?.city}`}
                                  {parsedBillingAddress?.state &&
                                    `, ${parsedBillingAddress?.state}`}
                                  {parsedBillingAddress?.country &&
                                    `, ${parsedBillingAddress?.country}`}
                                  {parsedBillingAddress?.zipcode &&
                                    `, ${parsedBillingAddress?.zipcode}`}
                                </p>
                              </div>
                            </>
                          ) : (
                            <p className="fs-14 text-muted">
                              No Billing Address
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Shipping Address */}
                    <div className="">
                      <h3
                        className="pt-2 mb-2"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          marginBottom: 14,
                          color: "#0099ff",
                        }}
                      >
                        Shipping Address
                      </h3>

                      {parsedShippingAddress ? (
                        <>
                          {/* <div className="mb-0 fs-14 text-dark">
                            <span className="d-block fs-14 text-dark fw-bold">
                              {salesDetails?.contact_full_name &&
                                salesDetails?.contact_full_name}
                            </span>
                          </div> */}
                          <div style={{ fontSize: "13px", fontWeight: 300 }}>
                            <p style={{ fontSize: "13px", fontWeight: 300 }}>
                              {" "}
                              {parsedShippingAddress?.address}{" "}
                            </p>{" "}
                            <p
                              className="mb-3"
                              style={{ fontSize: "13px", fontWeight: 300 }}
                            >
                              {parsedShippingAddress?.city &&
                                `${parsedShippingAddress?.city}`}
                              {parsedShippingAddress?.state &&
                                `, ${parsedShippingAddress?.state}`}
                              {parsedShippingAddress?.country &&
                                `, ${parsedShippingAddress?.country}`}
                              {parsedShippingAddress?.zipcode &&
                                `, ${parsedShippingAddress?.zipcode}`}
                            </p>
                          </div>
                        </>
                      ) : (
                        <p className="fs-14 text-muted">Same as Billing</p>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>

              {/* 🔽 Status Section */}
              <div className="row mt-3 mb-3 pe-0 ms-0 ps-0">
                <h3
                  className="ps-0 mb-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                    color: "#0099ff",
                  }}
                >
                  Status
                </h3>

                {/* CARD 1: ORDER STATUS (Reference) */}
                <div className="col-md-6 mb-2 ps-0 pe-0">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Order Status
                    </p>

                    <p
                      id="fbaec39e-f512-4cf8-9fb8-e68fc86fad51"
                      className="text-uppercase fw-semibold"
                      style={{
                        fontSize: "14px",
                        letterSpacing: "0.4px",
                        padding: "0px",
                      }}
                    >
                      {salesDetails?.order_status == "approved" ? (
                        <a href="#" style={{ color: "rgb(91 142 85)" }}>
                          Approved
                        </a>
                      ) : salesDetails?.order_status == "pending" ? (
                        <a href="#" style={{ color: "#ac5050" }}>
                          Pending
                        </a>
                      ) : salesDetails?.order_status == "draft" ? (
                        <a href="#" style={{ color: "rgb(228 217 15)" }}>
                          Draft
                        </a>
                      ) : (
                        <a href="#" style={{ color: "rgb(108 117 125)" }}>
                          Reject
                        </a>
                      )}
                    </p>
                  </div>
                </div>

                {/* CARD 2: INVOICE (Updated) */}
                <div className="col-md-6 mb-2 pe-0">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Invoice
                    </p>
                    <p className="fw-semibold text-dark text-uppercase">
                      {" "}
                      {salesDetails?.invoiced_percentage == 100 ? (
                        <a
                          href="#"
                          style={{
                            fontSize: "14px",
                            color: "rgb(91 142 85)",
                            letterSpacing: "0.4px",
                            padding: "0px",
                          }}
                        >
                          Complete
                        </a>
                      ) : (
                        <a
                          href="#"
                          style={{
                            fontSize: "14px",
                            color: "#ac5050",
                            letterSpacing: "0.4px",
                            padding: "0px",
                          }}
                        >
                          Partially Complete
                        </a>
                      )}
                    </p>
                  </div>
                </div>

                {/* <div className="col-md-3 mb-2 pe-0">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Payment
                    </p>
                    <p className="fw-semibold text-dark">Unpaid</p>
                  </div>
                </div> */}

                {/* CARD 4: SHIPMENT (Updated) */}
                {/* <div className="col-md-3 mb-2 pe-0">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Shipment
                    </p>
                    <p className="fw-semibold text-dark">Pending</p>
                  </div>
                </div> 
                */}
              </div>
            </div>

            <Row
              id="itemsDetailsSection"
              style={{ width: "100%", marginLeft: 0, paddingRight: 4 }}
            >
              <h3
                className="ps-0 mb-3"
                style={{
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  fontSize: "19px",
                  color: "#0099ff",
                }}
              >
                Items Details
              </h3>

              <Col md={12} className="pe-0 ps-0">
                <div className="table-responsive quatationsTables2 mb-3 ">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th className="text-start">Items &amp; Description</th>
                        <th className="text-end">Quantity</th>
                        <th className="text-end">
                          GST(
                          <i className="bi bi-percent"></i>)
                        </th>
                        <th className="text-end">Rate</th>
                        <th className="text-end">
                          Discount(
                          <i className="bi bi-percent"></i>/
                          <i className="ti ti-currency-rupee"></i>)
                        </th>
                        <th className="text-center pe-2">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemsDetailsData[0]?.itemDetails?.map((item, index) => (
                        <tr key={index}>
                          <td className="text-start">
                            <div>
                              <p
                                className="w-100 mb-0 d-flex fs-13 align-items-center text-dark justify-content-between"
                                style={{
                                  fontWeight: 500,
                                  textTransform: "capitalize",
                                  width: "auto",
                                }}
                              >
                                {" "}
                                {item.name ?? "-"}
                              </p>
                              <p
                                className="mb-0"
                                style={{ cursor: "pointer", width: "auto" }}
                              >
                                {item.itemDescription || "-"}{" "}
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-2 pt-0 fs-13"
                            >
                              {item?.quantity ?? "-"}{" "}
                            </span>
                          </td>
                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-3 pt-0 fs-13"
                            >
                              {item?.gst ?? "-"}
                              <i className="bi bi-percent"></i>
                            </span>
                          </td>
                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-2 pt-0 fs-13"
                            >
                              {formatToINR(item?.Rate ?? "-")}
                            </span>
                          </td>

                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-3 pt-0 fs-13"
                            >
                              {item.discount}
                              {item.discountType === "Percentage" ? (
                                <i className="bi bi-percent"></i>
                              ) : (
                                <i className="ti ti-currency-rupee"></i>
                              )}
                            </span>
                          </td>

                          <td className="text-end">
                            <div className="d-flex gap-2 align-items-center justify-content-center pe-3">
                              <div
                                className="fs-13 text-end"
                                style={{ fontWeight: 500 }}
                              >
                                {formatToINR(item.discountedAmount ?? "-")}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}

                      <tr>
                        <th
                          className="text-start bg-transparent border-0 vertical-top w-100"
                          style={{ verticalAlign: "top" }}
                        >
                          <div className="mt-3 mb-3">
                            <p
                              className="ps-1 mb-2 fs-14"
                              style={{ fontWeight: 400 }}
                            >
                              Customer Note
                            </p>
                            <p className=" ps-1 text-wrap fs-13 fw-normal">
                              {salesDetails?.customer_note ?? "-"}
                            </p>
                          </div>
                        </th>
                        <th
                          colSpan={5}
                          className="text-start bg-transparent border-0 "
                        >
                          <div
                            className=" w-100 h-100 mt-3 mb-3 "
                            style={{
                              borderRadius: 5,
                              background: "#f9f9fb",
                              padding: "1rem",
                            }}
                          >
                            <div className="row sub-total mb-2 text-semibold ">
                              <div className="total-label col-md-6 d-flex align-items-center fw-500 fs-14">
                                Sub Total
                              </div>
                              <div className="total-amount text-end fw-500 fs-14 col-md-6 d-flex align-items-center gap-1 justify-content-end">
                                {/* {formatToINR(items[0]?.subTotal)} */}
                                {formatToINR(
                                  itemsDetailsData[0]?.["sub-total"],
                                )}
                              </div>
                            </div>
                            <div className="row sub-total mb-1">
                              <div className="total-label col-md-4 d-flex  align-items-center text-secondary fw-400 fs-13">
                                Special Discount
                                <span className="ps-1 fs-13">
                                  ({itemsDetailsData[0]?.special_discount}
                                  <span className="pe-1">
                                    <i>
                                      {
                                        itemsDetailsData[0]
                                          ?.special_DiscountType
                                      }
                                    </i>
                                  </span>
                                  )
                                </span>
                              </div>

                              <div className="total-amount text-end fs-13 text-secondary fw-400 col-md-8 d-flex align-items-center justify-content-end">
                                -
                                {formatToINR(
                                  itemsDetailsData[0]
                                    ?.special_Discount_Amount || 0,
                                )}
                              </div>
                            </div>
                            <div className="row sub-total mb-1">
                              <div className="total-label col-md-4 d-flex fw-400 text-secondary align-items-center fs-13">
                                Shipping Charge
                              </div>

                              <div className="total-amount text-end fw-400 fs-13 text-secondary col-md-8 d-flex align-items-center gap-1 justify-content-end">
                                {formatToINR(
                                  itemsDetailsData[0]?.shipping_Charge || 0,
                                )}
                              </div>
                            </div>

                            <div>
                              {itemsDetailsData[0]?.gstBreakdown?.map((gst) => (
                                <div
                                  className="row sub-total mb-1"
                                  key={gst?.gst}
                                >
                                  <div className="total-label col-md-4 fw-400 d-flex text-secondary align-items-center fs-13">
                                    GST
                                    <span className="ps-1 fw-400 text-secondary fs-13">
                                      ({gst?.gst}%)
                                    </span>
                                  </div>
                                  <div className="total-amount text-end fw-400 col-md-8 fs-13 text-secondary d-flex align-items-center justify-content-end gap-1">
                                    {formatToINR(
                                      Number(`${gst?.amount}`).toFixed(2),
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>

                            <hr />
                            <div className="row sub-total text-semibold ">
                              <div className="total-label col-md-6 fs-14">
                                Grand Total
                              </div>
                              <div className="total-amount text-end text-semibold col-md-6 fs-14">
                                {/* {formatToINR(items[0]?.grandTotal)} */}
                                {formatToINR(
                                  itemsDetailsData[0]?.grand_total || 0,
                                )}
                              </div>
                            </div>
                          </div>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>

            {/* 🔽 Total Section */}
            <Row id="termsAndConditionsSec" className="mt-3">
              <Col md={8}>
                <h3
                  className=" mb-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                    color: "#0099ff",
                  }}
                >
                  Terms & Conditions
                </h3>

                <Form.Group className="mb-3" controlId="formTerms">
                  <p className="ps-1 mb-2 fs-13" style={{ fontWeight: 400 }}>
                    {salesDetails.terms_condition
                      ? TextWithLineBreaks(salesDetails.terms_condition)
                      : "Terms and conditions not available"}
                  </p>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <h3
                  className=" mb-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                    color: "#0099ff",
                  }}
                >
                  Attachment
                </h3>
                <div
                  style={{
                    borderRadius: "10px",
                    padding: "10px 0px",
                    textAlign: "start",
                    width: "100%",
                    maxWidth: "400px",
                    margin: "0px",
                  }}
                >
                  <p
                    style={{ marginBottom: "5px", color: "#666" }}
                    className="d-flex align-items-center"
                  >
                    <FontAwesomeIcon
                      icon={faPaperclip}
                      className="me-2 fs-20"
                      style={{ color: "#0099ff", flexShrink: 0 }}
                    />
                    {salesDetails.attachment ? (
                      <a
                        href={`${imageURL}${salesDetails.attachment}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#0099ff",
                          textDecoration: "underline",
                          /* --- START FIX --- */
                          wordBreak: "break-all", // Forces the text to break anywhere necessary
                          overflowWrap: "anywhere", // Ensures it wraps within the container
                          /* --- END FIX --- */
                        }}
                      >
                        {salesDetails.attachment.split("/").pop()}
                      </a>
                    ) : (
                      "No attachment"
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          {/* toggle2 */}
          <div
            className="card shadow mt-4"
            id="pdfsViews"
            style={{ display: pdfView ? "block" : "none" }}
          >
            <div className="card-body pt-0">
              <div className="row w-100 ms-0">
                {/* Header */}
                <div className="col-md-6 ps-0">
                  <img
                    src={pugcrm_logo}
                    alt="logo"
                    style={{ height: "130px", width: "160px" }}
                  />
                </div>
                <div className="col-md-6 d-flex align-items-center justify-content-end ps-0">
                  <h2 className="mb-1">Sales Order</h2>
                  {/* <p className="mb-1 fs-13">
                    Sales Order : #{salesDetails?.sale_no || "-"}
                  </p> */}
                </div>
              </div>
              {/* Billed, Billing, Sales Details */}
              <div className="row mt-4 mb-4  w-100 ms-0">
                <div className="col-md-4 px-2 d-flex align-items-start justify-content-start flex-column">
                  <p className="mb-2 fw-semibold fs-14">Billed By</p>
                  <p className="mb-1 text-black fw-semibold">
                    {salesDetails?.company_name && salesDetails?.company_name}
                  </p>
                  <p className="mb-1 fs-13">
                    {parsedCompanyBillingAddress.length > 0 ||
                      parsedCompanyBillingAddress !== null ||
                      parsedCompanyBillingAddress !== undefined ? (
                      <>
                        <p className="mb-1 fs-13">
                          {parsedCompanyBillingAddress[0]?.address &&
                            parsedCompanyBillingAddress[0]?.address}
                        </p>
                        <p className="mb-1 fs-13">
                          {/* {parsedCompanyBillingAddress[0].city &&
                            `${parsedCompanyBillingAddress[0].city}`}
                          {parsedCompanyBillingAddress[0].state &&
                            `, ${parsedCompanyBillingAddress[0].state}`}
                          {parsedCompanyBillingAddress[0].country &&
                            `, ${parsedCompanyBillingAddress[0].country}`}
                          {parsedCompanyBillingAddress[0]?.zipcode &&
                            `, ${parsedCompanyBillingAddress[0].zipcode}`} */}
                          <p className="mb-1 fs-13">
                            {[
                              parsedCompanyBillingAddress[0]?.city,
                              parsedCompanyBillingAddress[0]?.state,
                              parsedCompanyBillingAddress[0]?.country,
                              parsedCompanyBillingAddress[0]?.zipcode,
                            ]
                              .filter(Boolean)
                              .join(", ")}
                          </p>
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="fs-13 mb-1">{salesDetails?.address}</p>
                        <p className="fs-13 mb-1">
                          {salesDetails.city_name &&
                            `${salesDetails.city_name}`}
                          {salesDetails.state_name &&
                            `, ${salesDetails.state_name}`}
                          {salesDetails.nicename &&
                            `, ${salesDetails.nicename}`}
                          {salesDetails.zipcode && `, ${salesDetails.zipcode}`}
                        </p>
                      </>
                    )}
                  </p>
                </div>
                <div className="col-md-4 px-2">
                  <p className="mb-2 fw-semibold fs-14">Billed To</p>
                  <p className="mb-1 text-black fw-semibold">
                    {salesDetails.contact_name && salesDetails?.contact_name}
                  </p>
                  <p className="mb-1 fs-13">
                    {parsedBillingAddress.address &&
                      parsedBillingAddress.address}{" "}
                  </p>
                  <p className="mb-1 fs-13">
                    {parsedBillingAddress.city &&
                      `${parsedBillingAddress.city}`}
                    {parsedBillingAddress.state &&
                      `, ${parsedBillingAddress.state}`}
                    {parsedBillingAddress.country &&
                      `, ${parsedBillingAddress.country}`}
                    {parsedBillingAddress.zipcode &&
                      `, ${parsedBillingAddress.zipcode}`}
                  </p>
                  {/* <p className="mb-1 fs-13">{salesDetails?.email || "email"}</p> */}
                </div>
                <div className="col-md-4 px-2">
                  <p className="mb-2 fw-semibold fs-14">Sales Order Details</p>
                  <p className="mb-1 fs-13">
                    Sales Order No.:
                    <span className="fs-14 ms-1 fw-semibold text-black">
                      #{salesDetails?.sale_no || "-"}
                    </span>
                  </p>
                  <p className="mb-1 fs-13">
                    Sales Order Date:
                    <span className="fs-14 ms-1 fw-semibold text-black">
                      {formatDate(salesDetails?.sales_order_date) || "-"}
                    </span>
                  </p>
                  <p className="mb-1 fs-13">
                    Shipment Date:
                    <span className="fs-14 ms-1 fw-semibold text-black">
                      {formatDate(salesDetails?.shipment_date) || "-"}
                    </span>
                  </p>
                </div>
              </div>

              <Row>
                <Row
                  id="itemsDetailsSection"
                  style={{ width: "100%", marginLeft: 0, paddingRight: 4 }}
                >
                  {/* <h3
                    className="ps-0 mb-3"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 300,
                      fontSize: "19px",
                      color: "#0099ff",
                    }}
                  >
                    Items Details
                  </h3> */}

                  <Col md={12} className="pe-0 ps-0">
                    <div className="table-responsive quatationsTables2 mb-3 ">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th className="text-start">
                              Items &amp; Description
                            </th>
                            {/* <th className="text-end">
                              HSN/SAC
                            </th> */}
                            <th className="text-end">
                              GST(
                              <i className="bi bi-percent"></i>)
                            </th>
                            <th className="text-end">Quantity</th>
                            <th className="text-center ">
                              Rate(<i className="ti ti-currency-rupee"></i>)
                            </th>
                            <th className="text-end">
                              Discount(
                              <i className="bi bi-percent"></i>/
                              <i className="ti ti-currency-rupee"></i>)
                            </th>
                            <th className="text-end ">
                              IGST(
                              <i className="bi bi-percent"></i>)
                            </th>
                            <th className="text-center pe-2">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {itemsDetailsData[0]?.itemDetails?.map(
                            (item, index) => (
                              <tr key={index}>
                                <td className="text-start">
                                  <div>
                                    <p
                                      className="mb-0 w-100 d-flex fs-13 align-items-center justify-content-between"
                                      style={{ fontWeight: 500, width: "auto" }}
                                    >
                                      {item.name ?? "-"}
                                    </p>
                                    <p
                                      className="mb-0 fs-12"
                                      style={{
                                        cursor: "pointer",
                                        width: "auto",
                                      }}
                                    >
                                      {item.itemDescription || "-"}{" "}
                                    </p>
                                  </div>
                                </td>
                                {/* <td className="text-end">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-3 pt-0 fs-12"
                                  >
                                    Code
                                  </span>
                                </td> */}

                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-3 pt-0 fs-12"
                                  >
                                    {item?.gst ?? "-"}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-2 pt-0 fs-12"
                                  >
                                    {item?.quantity ?? "-"}{" "}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-2 pt-0 fs-12"
                                  >
                                    {formatToINR(item?.Rate ?? "-")}
                                  </span>
                                </td>

                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-3 pt-0 fs-12"
                                  >
                                    {item.discount}
                                    {item.discountType === "INR" ? (
                                      <i className="ti ti-currency-rupee"></i>
                                    ) : (
                                      <i className="bi bi-percent"></i>
                                    )}
                                  </span>
                                </td>

                                <td className="text-end ">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-3 pt-0 fs-12"
                                  >
                                    {item?.gst ?? "-"}
                                    <i className="bi bi-percent"></i>
                                  </span>
                                </td>

                                <td className="text-end">
                                  <div className="d-flex gap-2 align-items-center justify-content-center ">
                                    <div
                                      className="fs-12 text-end pe-2"
                                      style={{ fontWeight: 500, fontSize: 12 }}
                                    >
                                      {formatToINR(
                                        item.discountedAmount ?? "-",
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ),
                          )}
                          {/* tr */}
                          {/* <tr>
                            <th
                              colSpan={5}
                              className="text-start bg-transparent border-0 "
                            ></th>
                          </tr> */}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>

                {/* 🔽 Total Section */}
                {/* <Row id="termsAndConditionsSec" className="mt-3">
                  <Col md={8}>
                    <h3
                      className=" mb-3"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "#0099ff",
                      }}
                    >
                      Terms & Conditions
                    </h3>

                    <Form.Group className="mb-3" controlId="formTerms">
                      <p
                        className="ps-1 mb-2 fs-13"
                        style={{ fontWeight: 400 }}
                      >
                        {salesDetails.terms_condition
                          ? TextWithLineBreaks(salesDetails.terms_condition)
                          : "Terms and conditions not available"}
                      </p>
                    </Form.Group>
                  </Col>
                </Row> */}
              </Row>

              <Row id="termsAndConditionsSec" className="mt-3">
                <Col md={6} className="pt-2 ">
                  <div className="d-flex flex-column">
                    <div>
                      <h3
                        className="mb-2 fs-14"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 400,
                        }}
                      >
                        Terms & Conditions
                      </h3>
                      <Form.Group className="mb-3" controlId="formTerms">
                        <p className="mb-2 fs-13" style={{ fontWeight: 400 }}>
                          {salesDetails.terms_condition
                            ? TextWithLineBreaks(salesDetails.terms_condition)
                            : "Terms and conditions not available"}
                        </p>
                      </Form.Group>
                    </div>
                    <div className="mt-1">
                      <h3
                        className=" mb-2 fs-14"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 400,
                        }}
                      >
                        Additional Notes
                      </h3>
                      <p className=" text-wrap fs-13 fw-normal">
                        {salesDetails?.customer_note ?? "-"}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    style={{
                      backgroundColor: "papayawhip",
                      borderRadius: "4px",
                    }}
                  >
                    <div className="text-start border-0">
                      <div className="w-100 h-100">
                        <div style={{ padding: "1rem" }}>
                          <div className="row sub-total mb-2 text-semibold ">
                            <div className="total-label fw-semibold col-md-7 d-flex fs-14 align-items-center">
                              Amount
                            </div>
                            <div className="total-amount fs-14 text-end fw-semibold col-md-5 d-flex align-items-center gap-1 justify-content-end">
                              {/* {formatToINR(items[0]?.subTotal)} */}
                              {formatToINR(itemsDetailsData[0]?.["sub-total"])}
                            </div>
                          </div>
                          <div className="row sub-total mb-1">
                            <div className="total-label col-md-7 fs-13 d-flex  align-items-center">
                              Special Discount
                              <span className="ps-1 fs-13">
                                ({itemsDetailsData[0]?.special_discount}
                                <span className="pe-1">
                                  <i>
                                    {itemsDetailsData[0]?.special_DiscountType}
                                  </i>
                                </span>
                                )
                              </span>
                            </div>

                            <div className="total-amount text-end fs-13 text-semibold col-md-5 d-flex align-items-center justify-content-end">
                              -
                              {formatToINR(
                                itemsDetailsData[0]?.special_Discount_Amount ||
                                0,
                              )}
                            </div>
                          </div>
                          <div>
                            {itemsDetailsData[0]?.gstBreakdown?.map((gst) => (
                              <div
                                className="row sub-total mb-1"
                                key={gst?.gst}
                              >
                                <div className="total-label col-md-7 d-flex align-items-center fs-13">
                                  IGST
                                  <span className="ps-1 fs-13">
                                    ({gst?.gst}%)
                                  </span>
                                </div>
                                <div className="total-amount text-end col-md-5 fs-13 d-flex align-items-center justify-content-end gap-1">
                                  {formatToINR(
                                    Number(`${gst?.amount}`).toFixed(2),
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="row sub-total mb-1">
                            <div className="total-label col-md-7 d-flex align-items-center fs-13">
                              Shipping Charge
                            </div>
                            <div className="total-amount fs-13 text-end text-semibold col-md-5 d-flex align-items-center gap-1 justify-content-end">
                              {formatToINR(
                                itemsDetailsData[0]?.shipping_Charge || 0,
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Grand Total Bar (Blue) */}
                        <div
                          className="row sub-total fw-semibold py-2 mx-0"
                          style={{
                            backgroundColor: "rgb(0, 153, 255)",
                            color: "#ffff",
                            borderBottomLeftRadius: "4px",
                            borderBottomRightRadius: "4px",
                          }}
                        >
                          <div className="total-label fw-semibold fs-14 col-md-6 ps-3">
                            Total
                          </div>
                          <div className="total-amount fs-14 text-end fw-semibold col-md-6 pe-3">
                            {formatToINR(
                              itemsDetailsData[0]?.["grand_total"] || 0,
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="mt-4 fs-13 ps-0">
                <p>Authorised Signature _________________</p>
              </div>
            </div>
          </div>

          {isMyApproval ? (
            <div className="d-flex justify-content-end gap-2 px-3 mt-3">
              <button
                className="btn btn-default-outline"
                onClick={() => {
                  setOpenRejectReasonModal(true);
                }}
              >
                Reject
              </button>
              <button
                className="btn btn-default"
                onClick={() => {
                  approveOrder(false);
                }}
              >
                Approve
              </button>
            </div>
          ) : (
            <></>
          )}
        </Offcanvas.Body>
        {openRejectReasonModal && (
          <Modal
            show={openRejectReasonModal}
            onHide={() => setOpenRejectReasonModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>What is the reason for your rejection</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input
                type="text"
                placeholder="enter your rejection reason"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
              />
              <div className="d-flex justify-content-end gap-3 px-2 mt-3">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => {
                    setRejectReason("");
                    setOpenRejectReasonModal(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-default"
                  onClick={() => {
                    setOpenRejectReasonModal(false);
                    approveOrder(true);
                  }}
                >
                  Save
                </button>
              </div>
            </Modal.Body>
          </Modal>
        )}
        {openClone && (
          <EditSalesOrder
            data={salesDetails}
            isClone={isClone}
            isEditOpen={isEditOpen}
            setIsEditOpen={setIsEditOpen}
            onClose={() => setOpenClone(false)}
            salesOrderId={salesDetails?.id || ""}
            refresh={fetchSalesOrder}
          />
        )}
        {editOpen && (
          <EditSalesOrder
            data={salesDetails}
            // isClone={isClone}
            isEditOpen={isEditOpen}
            setIsEditOpen={setIsEditOpen}
            onClose={() => {
              setEditOpen(false);
            }}
            salesOrderId={salesDetails?.id || ""}
            refresh={fetchSalesOrder}
          />
        )}
      </Offcanvas>
      <style jsx>
        {`
          .sales-order-accordion .accordion-button:not(.collapsed) {
            background-color: #ffffff;
            box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0
              var(--bs-accordion-border-color);
            color: var(--bs-accordion-active-color);
          }

          .list-unlisted {
            list-style: none !important;
            display: flex !important;
            width: fit-content !important;
            text-align: center !important;
            border-bottom: none !important;
            background-color: #ffffff !important;
            margin-bottom: 0px !important;
            width: 100% !important;
            padding-left: 0px !important;
            border-top: none !important;
          }

          .list-unlisted .listed {
            padding: 6px 12px !important;
            border-left: 1px solid #ebeaf2 !important;
            font-size: 13px !important;
            cursor: pointer !important;
            background: #e9e9e9 !important;
            color: #373636 !important !important;
            border-radius: 3px !important;
          }

          .quatationsTables2 table thead tr th {
            font-size: 0.8rem !important;
            background: #dbdbdb57 !important;
            padding: 0px 16px !important;
            height: 2.5rem;
            font-family: "Inter", sans-serif !important;
            line-height: 1.5;
            letter-spacing: 0.0573rem;
            border-bottom: 1px solid #d8e6f7 !important;
            border-radius: 0px !important;
          }

          .quatationsTables2 table thead tr th:first-child {
            border-top-left-radius: 0px !important;
            /* width: 60px; */
            text-align: center;
            background: #dbdbdb57 !important;
            font-weight: 300;
            color: black !important;
          }
          .quatationsTables2 .table thead {
            position: relative !important;
            height: auto !important;
            top: 0px;
          }

          .accordion-table thead {
            position: relative !important;
            height: auto !important;
            top: 0px;
          }

          .quatationsTables2 table tbody tr td {
            font-size: 13px !important;
          }
          .quatationsTables2 table tbody tr:last-child th:first-child {
            border-right: none !important;
          }
          .quatationsTables2 table thead tr th:last-child {
            border-top-right-radius: 0px !important;
            /* width: 60px; */
            text-align: center;
            /* background: #dbdbdb57 !important; */
            font-weight: 300;
            color: black !important;
          }

          .quatationsTables2.table-responsive {
            border: 1px solid lightblue !important;
            border-radius: 5px !important;
          }

          .quatationsTables2.table-responsive table {
            border-radius: 5px !important;
          }

          .quatationsTables2 tr th {
            padding: 10px 7px 10px 10px !important;
            border-right: 1px solid #bababa !important;
          }

          .quatationsTables2 tr td {
            padding: 7px 7px 7px 15px !important;
            border-bottom: 1px solid #d1e9f1 !important;
            border-right: 1px solid #bababa !important;
          }
        `}
      </style>
    </>
  );
};

const styles = {
  valuesStyle: {
    marginBottom: 0,
    paddingTop: 4,
    paddingLeft: 0,
    fontSize: "0.77rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 400,
    color: "black",
  },
  valuesStyleForPdf: {
    marginBottom: 0,
    paddingTop: 4,
    paddingLeft: 0,
    fontSize: "0.75rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 400,
    color: "black",
  },
  valuesStyle1: {
    marginBottom: 0,
    paddingTop: 25,
    paddingLeft: 13,
    fontSize: "0.87rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 500,
    color: "black",
    cursor: "pointer",
  },
  lableText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    lineHeight: "normal",
    fontSize: "13px",
    fontWeight: 300,
  },
  cardDiv: {
    border: "1px solid lightblue",
    borderRadius: "3px",
    padding: "18px 18px",
    lineHeight: "0.6rem",
  },
  cardLabel: {
    marginBottom: 1,
    fontSize: "13px",
    fontWeight: 300,
    minWidth: "125px",
  },
  cardLebelData: {
    textTransform: "capitalize",
    color: "black",
    fontWeight: 400,
    fontSize: "13px",
  },
};
